import { render, staticRenderFns } from "./MetricListScreen.vue?vue&type=template&id=4b328f47"
import script from "./MetricListScreen.vue?vue&type=script&lang=js"
export * from "./MetricListScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports